import { Link } from 'react-router-dom';
import { Plus, type LucideIcon } from 'lucide-react';
import { tr } from '@/lib/i18n-core';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/primitives';
import { ShellSectionHeading } from '@/components/clinical-shell/ShellPanel';
import { admissionIsOpen, type Admission } from '../../admission/types';
import { OrderList } from './OrderList';

export function OrdersSection({ admission, icon, newOrderHref }: { admission: Admission; icon: LucideIcon; newOrderHref: string }) {
  const { can } = useAuth();
  const current = admissionIsOpen(admission);

  return (
    <>
      <ShellSectionHeading
        icon={icon}
        title={tr('ipd', 'ws_emr_orders')}
        description={tr('ipd', 'io_ord_orders_desc')}
        actions={
          current && can('cpoe.write') ? (
            <Link to={newOrderHref}>
              <Button size="sm">
                <Plus className="h-4 w-4" aria-hidden /> {tr('ipd', 'new_order')}
              </Button>
            </Link>
          ) : null
        }
      />
      <OrderList admission={admission} filterByKind />
    </>
  );
}
